// @flow

import * as React from 'react';
import moment from 'moment';
import { ISO_DAYS } from 'common/domain/DayOfWeek';
import SpecificDateRangePicker, { DateRangePickerProps } from './SpecificDateRangePicker';

const ISO_WEEKEND_DAYS = [ISO_DAYS.SUNDAY, ISO_DAYS.SATURDAY];

export default function WeekEndPicker(props: DateRangePickerProps) {
  return (
    <SpecificDateRangePicker
      {...props}
      disabledDates={getDisabledDates(props)}
      getRange={findWeekEndFor}
      selectableISODays={ISO_WEEKEND_DAYS}
    />
  );
}

function getDisabledDates({ minDate, maxDate }: DateRangePickerProps) {
  const disabled = {};

  const isWeekend = date => date.isoWeekday() === 6 || date.isoWeekday() === 7;
  if (minDate && isWeekend(minDate)) {
    disabled.before = minDate.clone().isoWeekday(8).toDate();
  }

  if (maxDate && isWeekend(maxDate)) {
    disabled.after = maxDate.clone().isoWeekday(5).toDate();
  }

  return disabled;
}

function findWeekEndFor(day: Date) {
  const date = moment(day);

  switch (date.isoWeekday()) {
    case 6:
      return {
        from: day,
        to: date.clone().isoWeekday(7).toDate(),
      };
    case 7:
      return {
        from: date.clone().isoWeekday(6).toDate(),
        to: day,
      };
    default:
      return {
        from: undefined,
        to: undefined,
      };
  }
}




// WEBPACK FOOTER //
// ./src/common/components/ui/datePicker/WeekEndPicker.js